import 'jquery/dist/jquery.min';
import 'jquery-validation/dist/jquery.validate.min';
import 'jquery-validation/dist/additional-methods.min';
import jquery from 'jquery';

const reset_password_form = $('#reset_password_form');
reset_password_form.validate({
        errorClass: "invalid",
        validClass: "valid",
        // errorElement: "em",
        rules: {
            user_email:{
                email:true,
            },
        },
        onfocusout: function(element) {
            this.element(element); // triggers validation
        },
        onkeyup: function(element, event) {
            this.element(element); // triggers validation
        },
        messages: {
            user_email: {
                required: "Please enter the Email",
            }
        },
        errorElement: "em",
        errorPlacement: function ( error, element ) {
            // Add the `help-block` class to the error element
            error.addClass( "alert alert-danger d-flex align-items-center mt-2" );

            // Add `has-feedback` class to the parent div.form-group
            // in order to add icons to inputs
            element.parents( ".input-field" ).addClass( "is-invalid" );

            if ( element.prop( "type" ) === "checkbox" ) {
                error.insertAfter( element.parent( "label" ) );
            } else {
                error.insertAfter( element );
            }
        },
        success: function ( label, element ) {
           // //console.log('success');
           //hide error alert
           $( element ).addClass( "is-valid" ).removeClass( "-invalid" );
           $( element ).siblings( 'em' ).removeClass( "alert alert-danger d-flex align-items-center mt-2" );
        },
        highlight: function ( element, errorClass, validClass ) {
            $( element ).addClass( "is-invalid" ).removeClass( "is-valid" );
            // $( element ).next( "span" ).addClass( "is-valid" ).removeClass( "is-invalid" );
            $( element ).siblings( 'em' ).addClass( "alert alert-danger d-flex align-items-center mt-2" );

        },
        unhighlight: function ( element, errorClass, validClass ) {
            $( element ).addClass( "is-valid" ).removeClass( "is-invalid" );
            $( element ).siblings( 'em' ).removeClass( "alert alert-danger d-flex align-items-center mt-2" );

        }  

    }) ;